import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=A%20dramatic%20and%20artistic%20Korean%20manhwa%20style%20illustration%20showing%20an%20epic%20fantasy%20landscape%20with%20floating%20islands%20and%20magical%20energy%20swirls%2C%20warm%20golden%20and%20coral%20color%20palette%2C%20cinematic%20composition%20with%20deep%20atmospheric%20depth%2C%20stylized%20Korean%20webtoon%20aesthetic%2C%20dramatic%20clouds%20and%20light%20rays&width=1800&height=800&seq=hero-bg-main&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/55" />

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight max-w-3xl">
          高清下拉式韩漫全集
          <br />
          <span className="text-primary-400">免费阅读</span>，畅享无限
        </h1>
        <p className="mt-5 text-sm md:text-lg text-background-200/80 max-w-2xl leading-relaxed">
          韩漫之家作为专业在线免费韩漫阅读平台，汇集海量韩国漫画资源，
          恋爱、奇幻、动作、悬疑等多种分类，更新速度快，画质高清，
          下拉式阅读体验流畅，让您随时随地免费畅读心仪韩漫。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-4">
          <Link
            to="/category/love"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full transition-all duration-300 text-sm whitespace-nowrap cursor-pointer"
          >
            立即开始阅读
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 backdrop-blur-sm font-medium rounded-full transition-all duration-300 text-sm whitespace-nowrap cursor-pointer border border-background-50/20"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-12 flex items-center gap-8">
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-background-50">2000+</p>
            <p className="text-xs text-background-200/70 mt-1">韩漫作品</p>
          </div>
          <div className="w-px h-10 bg-background-50/20" />
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-accent-400">500万+</p>
            <p className="text-xs text-background-200/70 mt-1">活跃读者</p>
          </div>
          <div className="w-px h-10 bg-background-50/20" />
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-background-50">每日更新</p>
            <p className="text-xs text-background-200/70 mt-1">同步韩国</p>
          </div>
        </div>
      </div>
    </section>
  );
}